import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { addLabelBatchStatusModalBatch } from '../../../../../store/batches/label-batch-status-modal/batches.label-batch-status-modal.actions';
import { openLabelBatchStatusModal } from '../../../../../components/label-que/components/label-que-batch-tile/components/order-or-batch-number';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import style from './style.module.less';

const BatchProcessingComplete = ({ fulfillmentPlanSet }) => {
  const dispatch = useDispatch();
  const { fulfillmentPlanSetId, note, fulfillmentPlanSetName: name, assignedToUserGuid: assignedToGuid } = fulfillmentPlanSet;

  const onOpenLabelBatchStatus = useCallback(() => {
    dispatch(
      addLabelBatchStatusModalBatch({
        ...fulfillmentPlanSet,
        batchNotes: note,
        batchNumber: name,
        batchId: fulfillmentPlanSetId,
        userId: assignedToGuid,
      }),
    );
    openLabelBatchStatusModal(fulfillmentPlanSetId.toString());
  }, [fulfillmentPlanSet, dispatch, note, name, fulfillmentPlanSetId, assignedToGuid]);

  return (
    <div className={style['processing-column-cell']}>
      <FontAwesomeIcon className={style['completed-icon']} icon={faCheckCircle} />
      <Button className={style['complete-link']} onClick={onOpenLabelBatchStatus} theme='link'>
        <FormattedMessage {...messages.completeStatusLink} />
      </Button>
    </div>
  );
};

BatchProcessingComplete.propTypes = {
  fulfillmentPlanSet: PropTypes.object.isRequired,
};

export { BatchProcessingComplete };
